import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  booleanAttribute,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';

import { SvgIconComponent } from '@dmb/core';

import { ButtonComponent } from '../button/button.component';
import { BaseInputComponent } from '../input/base-input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dmb-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [BaseInputComponent, MatIconButton, SvgIconComponent, ButtonComponent],
})
export class FilterComponent<T extends { name: string; level?: number }> {
  listItems = input<T[]>([]);
  allLabels = input(false, { transform: booleanAttribute });
  placeholder = input<string>();
  dataChange = output<T | undefined>();
  cancelled = output<void>();

  filterVal = signal('');
  selected = signal<T | 'all' | undefined>(undefined);
  hasSelection = computed(() => this.selected() !== undefined);
  filteredItems = computed(() => {
    const compareVal = this.filterVal().trim().toLowerCase();
    const items = this.listItems();
    return items.filter((n) => n.name.toLowerCase().includes(compareVal));
  });

  clearSearch(): void {
    this.filterVal.set('');
  }

  selectItem(item: T): void {
    this.selected.set(item);
  }

  selectAll(): void {
    this.clearSearch();
    this.selected.set('all');
  }

  choose(): void {
    const selection = this.selected();
    if (selection === undefined) {
      return;
    }
    this.dataChange.emit(selection === 'all' ? undefined : selection);
  }

  cancel(): void {
    this.selected.set(undefined);
    this.cancelled.emit();
  }
}
